'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UniqueUsername = function () {
  function UniqueUsername($q, AccountService) {
    'ngInject';

    _classCallCheck(this, UniqueUsername);

    Object.assign(this, {
      $q: $q,
      AccountService: AccountService
    });

    this.require = 'ngModel';
    this.restrict = 'A';
  }

  _createClass(UniqueUsername, [{
    key: 'link',
    value: function link($scope, element, attrs, ctrl) {
      var _this = this;

      var userId = null;

      if (attrs.userId) {
        userId = attrs.userId;
      }

      // Async validator requires resolve or reject to set validity
      ctrl.$asyncValidators.uniqueUsername = function (username) {
        var defer = _this.$q.defer();

        _this.AccountService.isUniqueUsername(username, userId).then(function (r) {
          if (r.data) {
            defer.resolve();
          }

          defer.reject();
        }).catch(function () {
          return defer.reject();
        });

        return defer.promise;
      };
    }
  }], [{
    key: 'directiveFactory',
    value: function directiveFactory($q, AccountService) {
      'ngInject';

      return new UniqueUsername($q, AccountService);
    }
  }]);

  return UniqueUsername;
}();

exports.default = UniqueUsername;


// WEBPACK FOOTER //
// ./common/directives/validation/unique-username.js